export const LOGIN_ACTIONS = {
  SET_LOGIN: "SetLogin",
  SET_LOGIN_INFO: "SetLoginInfo",
  TOGGLE_REMEMBER_ME: "ToggleRememberMe",
  TOGGLE_SHOW_PASSWORD: "ToggleShowPassword"
};
